import React from 'react'
import EllipseBase from 'src/components/feedback/ellipse/EllipseBase'

const UnreadSign: React.FC = () => <EllipseBase color="error" size={8} />

export default UnreadSign
